/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@compiled/react';

import EmptyState from '@atlaskit/empty-state/empty-state';
import type { EmptyStateProps } from '@atlaskit/empty-state/types';
import { Box } from '@atlaskit/primitives/compiled';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- TODO: migrate to @atlaskit/primitives/compiled
import Text from '@atlaskit/primitives/text';
import { token } from '@atlaskit/tokens';

import { GenericErrorIcon } from './assets/GenericErrorIcon';

const styles = cssMap({
	textWrapper: {
		maxWidth: '235px',
		marginInline: 'auto',
		display: 'inline-block',
	},
	imageWrapper: {
		paddingBottom: token('space.500'),
	},
});

export interface NavEmptyStateProps extends EmptyStateProps {}

export function NavEmptyState({
	testId = 'navigation-empty-state',
	renderImage = () => (
		<Box xcss={styles.imageWrapper}>
			<GenericErrorIcon />
		</Box>
	),
	description,
	...restProps
}: NavEmptyStateProps): JSX.Element {
	return (
		<EmptyState
			{...restProps}
			testId={testId}
			renderImage={renderImage}
			headingLevel={3}
			headingSize="xsmall"
			description={
				<span css={styles.textWrapper}>
					<Text size="small" color="color.text.subtle">
						{description}
					</Text>
				</span>
			}
		/>
	);
}
